<template>
  <div>
    <div v-if="hasAccessTokenIssues" class="alert alert-danger mb-3" role="alert">
      <strong>Google Account Connection Issue</strong><br>
      There was an issue with your Google Account Access Token that is affecting our services. 
      Please <router-link :to="{ name: 'business.settings' }" class="alert-link">reconnect your Google Account</router-link> to continue syncing reviews.
    </div>
    <div>
      <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab title="Reviews">
          <p style="margin-top:-20px">
            <ReviewList />
          </p>
        </b-tab>
        <b-tab title="Internal Feedback">
          <div style="margin-top:-20px">
            <div v-if="!loadingFeedback">
              <div v-if="datatable.items.length">
                <div class="table-responsive mb-0">
                <b-table
                  :items="datatable.items"
                  :fields="datatable.columns"
                  :tbody-tr-class="feedbackRowClass"
                  hover
                  @row-clicked="openFeedback"
                >
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                  <template v-slot:cell(feedback)="data">
                    {{data.item.feedback}}
                  </template>
                  <template v-slot:cell(rating)="data">
                    <span v-if="data.item.rating">{{ data.item.rating }}/5 <span class="feedback-star">★</span></span>
                    <span v-else class="text-muted">—</span>
                  </template>
                </b-table>
              </div>
                <div class="row mt-4">
                <div class="col">
                  <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                          v-model="datatable.queries.page"
                          :total-rows="datatable.totalItems"
                          :per-page="datatable.queries.per_page"
                          @change="onPageChanged"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div v-else class="mt-5">
                <h3 class="text-center">You do not currently have any feedback</h3>
              </div>
            </div>
            <div v-else class="text-center">
              <b-spinner></b-spinner>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <FeedbackDetailModal
      v-model="showFeedbackModal"
      :feedback="selectedFeedback"
      :loading="loadingSelectedFeedback"
    />
  </div>
</template>

<script>
import ReviewList from '@components/Common/ReviewsList.vue';
import FeedbackDetailModal from '@components/Business/Components/FeedbackDetailModal.vue';
import Vue from "vue";
export default {
  components:{
    ReviewList,
    FeedbackDetailModal,
  },
  data(){
    return {
      tabIndex: 0,
      highlightedFeedbackId: null,
      selectedFeedback: null,
      showFeedbackModal: false,
      loadingSelectedFeedback: false,
      datatable: {
        items: [],
        totalItems: 1,
        columns: [
          {key: 'name', thStyle: { width: '150px' }},
          {key: 'email'},
          {key: 'feedback'},
          {key: 'rating'},
          {key: 'front_date', label:'Date'},
        ],
        queries: {
          per_page: 10,
          page: 1,
        },
      },
      loadingFeedback:false,
      user:null
    }
  },
  computed:{
    hasAccessTokenIssues() {
      const user = this.$store.getters['auth/user'];
      console.log('=== DEBUG: Checking access token issues ===');
      console.log('User:', user);
      console.log('Google Accounts:', user?.google_accounts);
      
      if (!user || !user.google_accounts || !user.google_accounts.length) {
        console.log('No user or google_accounts found');
        return false;
      }
      
      // Check each account and location
      user.google_accounts.forEach((account, index) => {
        console.log(`Account ${index}:`, account);
        if (account.locations) {
          account.locations.forEach((location, locIndex) => {
            console.log(`  Location ${locIndex}:`, {
              id: location.id,
              name: location.name,
              title: location.title,
              has_access_token_issues: location.has_access_token_issues
            });
          });
        }
      });
      
      // Check if any location in any account has access token issues
      const hasIssues = user.google_accounts.some(account => 
        account.locations && account.locations.some(location => location.has_access_token_issues)
      );
      
      console.log('Has access token issues:', hasIssues);
      return hasIssues;
    }
  },
  mounted() {
    this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
    console.log('=== Reviews component mounted ===');
    console.log('User data:', this.user);
    console.log('Has access token issues:', this.hasAccessTokenIssues);
    this.getFeedback();
    if (this.$route.query.tab === 'feedback' || this.$route.query.feedback) {
      this.tabIndex = 1;
    }
    if (this.$route.query.feedback) {
      this.openFeedbackById(this.$route.query.feedback);
    }
  },
  methods:{
    feedbackRowClass(item) {
      return item && Number(item.id) === Number(this.highlightedFeedbackId) ? 'feedback-highlight' : 'feedback-row';
    },
    openFeedback(item) {
      this.highlightedFeedbackId = item.id;
      this.selectedFeedback = item;
      this.showFeedbackModal = true;
    },
    openFeedbackById(feedbackId) {
      this.highlightedFeedbackId = feedbackId;
      this.selectedFeedback = null;
      this.loadingSelectedFeedback = true;
      this.showFeedbackModal = true;
      this.$store
          .dispatch('reviews/getFeedback', { businessId: this.user.business.id, feedbackId })
          .then((res) => {
            this.selectedFeedback = res.data;
          })
          .catch(() => {
            this.selectedFeedback = null;
          })
          .finally(() => {
            this.loadingSelectedFeedback = false;
          });
    },
    onPageChanged(page) {
      this.datatable.queries.page = page
      this.getFeedback()
    },
    getFeedback() {
      this.loadingFeedback = true
      this.$store
          .dispatch('reviews/getAllFeedback', {
            queries:this.datatable.queries,
            page:'index',
            businessId:this.user.business.id
          })
          .then((res) => {
            console.log(res);
            this.datatable.items = res.data;
            this.datatable.totalItems = res.total;
            this.loadingFeedback = false
          })
          .catch(() => {
            this.loadingFeedback = false
          })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .feedback-row,
::v-deep .feedback-highlight {
  cursor: pointer;
}
::v-deep .feedback-highlight {
  background: #fef3c7;
}
.feedback-star {
  color: #ffb400;
}
</style>
